import React from "react";
import styles from "./DrMarkoWords.module.css";
import Image from "next/image";

interface TileDescription {
  id: number;
  title: string;
  description: string;
}
interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string;
}
interface TitleDescription {
  id: number;
  title_description: TileDescription;
  images: Image[];
}
interface ExecutiveChairpersonData {
  id: number;
  position: string;
  title_description: TitleDescription;
}
interface Props {
  data: ExecutiveChairpersonData;
}

const DrMarkoWords: React.FC<Props> = ({ data }) => {
  const { position, title_description } = data;
  return (
    <div className={styles.markoWords}>
      <div className="container">
        <div className={styles.TransformativeLearning}>
          <Image
            src={title_description?.images[0]?.url}
            alt={title_description?.images[0]?.alternativeText}
            title={title_description?.images[0]?.alternativeText}
            width={288}
            height={288}
          />
          <div className={styles.textBox}>
            <p>{title_description?.title_description?.description}</p>
            <div className={styles.caption}>
              <p>{title_description?.title_description?.title}</p>
              <span>{position}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrMarkoWords;
